<div class="page-section">
    <div class="page-title-section">
        <div class="text-section">
            <span>
                Prescription Product list
            </span>
        </div>
        <div class="btn-section">
        </div>
    </div>
    <div class="page-holder">
        <div class="left-section">
            <div class="menu-section" (click)="toggleInnerMenu('list')" [class.activeMenu]="activeInnerMenu == 'list'">
                <span>
                    <fa-icon icon="list-ul"></fa-icon> Prescription Products
                </span>
            </div>
            <div class="menu-section" (click)="toggleInnerMenu('prescription')" 
            [class.activeMenu]="activeInnerMenu == 'prescription'">
                <span>
                    <fa-icon icon="ban"></fa-icon> Toggle Prescriptions
                </span>
            </div>
            <div class="menu-section" (click)="goToPage('products/add');">
                <span>
                    <fa-icon icon="plus"></fa-icon> Add Product
                </span>
            </div>
        </div>
        <div class="right-section">
            <div class="menu-title-section">
                <span>
                    <b *ngIf="activeInnerMenu == 'list'">List of Deactivated Products</b>
                    <b *ngIf="activeInnerMenu == 'prescription'">Enable/Disabe prescription on a Product</b>
                </span>
            </div>
            <div class="menu-content">
                <ng-template [ngIf]="activeInnerMenu == 'list'">
                    <div class="content-section">
                        <div class="no-data-section"  *ngIf="products.length <= 0">
                            <div class="img-section">
                                <fa-icon icon="database"></fa-icon>
                            </div>
                            <div class="text-section">
                                <span>
                                    No Item Found
                                </span>
                            </div>
                            <div class="btn-section">
                                <button mat-flat-button (click)="toggleInnerMenu('prescription');">
                                    Enable Now
                                    
                                </button>
                            </div>
                        </div>
                        <div class="data-section" *ngIf="products.length > 0">
                            <div class="list-section">
                                <div class="list-item-section" *ngFor="let x of products; let i = index" >
                                    <div class="list-item-content" (click)="selectProduct(x)">
                                        <div class="icon-section">
                                            <div class="circle">
                                                <span>
                                                    {{x.firstLetterOfCategory}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="details-section">
                                            <div class="top-details-section">
                                                <span>
                                                    {{x.name}}
                                                </span>
                                            </div>
                                            <div class="middle-details-section">
                                                <span>
                                                    <b *ngFor="let y of x.unitOfMeasurement">
                                                        {{y}}, 
                                                    </b>
                                                </span>
                                            </div>
                                            <div class="down-details-section">
                                                <span>
                                                    {{x.category.name}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pagination-section">
                                <div class="pagination-text" (click)="getPage(1)">
                                    <span>
                                        First
                                    </span>
                                </div>
                                <div class="pagination-text" (click)="paginate(-1)">
                                    <span>
                                        Prev
                                    </span>
                                </div>
                                <div class="pagination-text" [class.activePage]="pageIndex == x"
                                *ngFor="let x of pageArray; let i = index" (click)="getPage(x)">
                                    <span>
                                        {{x}}
                                    </span>
                                </div>
                                <div class="pagination-text" (click)="paginate(1)">
                                    <span>
                                        Next
                                    </span>
                                </div>
                                <div class="pagination-text" (click)="getPage(noOfPages)">
                                    <span>
                                        Last
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template [ngIf]="activeInnerMenu == 'prescription'">
                    <div class="restock-content-section">
                        <div class="left-restock-content-section">
                            <div class="search-section">
                                <mat-form-field appearance="none">
                                    <input matInput type="text" name="searchData" autocomplete="off" 
                                    [(ngModel)]="searchData" placeholder="Search by product name" 
                                    (keyup)="searchEvent($event)" />
                                </mat-form-field>
                            </div>
                            <div class="search-result-section">
                                <div class="search-item-section" *ngFor="let x of searchResult; let i = index" 
                                (click)="chooseProduct(x)" [class.activeSearchItemSection]="x._id == productDetails.id">
                                    <div class="top-search-item-section">
                                        <span>
                                            {{x.name}}
                                        </span>
                                    </div>
                                    <div class="down-search-item-section">
                                        <span>
                                            {{x.category.name}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right-restock-content-section">
                            <form name="productForm" #productForm="ngForm"  class="form" *ngIf="productDetails.id"
                            (ngSubmit)="productForm.form.valid && togglePrescriptionProducts(productForm)">
                                <div class="big-form-control-section">
                                    <div class="label-section">
                                        <span>
                                            Product Name
                                        </span>
                                    </div>
                                    <div class="control-section">
                                        <mat-form-field appearance="none">
                                            <input matInput type="text" name="name" readonly
                                            [(ngModel)]="productDetails.name" #name="ngModel" required/>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="checkbox-section">
                                    <mat-checkbox name="status" [(ngModel)]="productDetails.status"
                                    [color]="'primary'">
                                        New Status: <b *ngIf="productDetails.status">ENABLED</b>
                                        <b *ngIf="!productDetails.status">DISABLED</b>
                                    </mat-checkbox>
                                </div>
                                <div class="btn-section">
                                    <button mat-flat-button>
                                        Change
                                        
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>